var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLineDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52184_116670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22248 4.00929C8.2183 3.90338 8.17473 3.78096 8.10211 3.70374L5.43546 0.88895C5.27976 0.704464 4.98022 0.708162 4.80517 0.874401C4.63012 1.04064 4.61575 1.33503 4.79199 1.50006L6.74567 3.56485H0.667013C0.421563 3.56485 0.222572 3.76384 0.222572 4.00929C0.222572 4.25476 0.421563 4.45374 0.667013 4.45374H6.74567L4.79199 6.51853C4.61578 6.68357 4.63021 6.97921 4.80532 7.14544C4.98037 7.31168 5.28416 7.31241 5.43555 7.12964L8.1022 4.31485C8.18332 4.22866 8.2213 4.12812 8.22248 4.00929Z",
    fill: "#E3ECF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52184_116670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.222626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineDark);
export default __webpack_public_path__ + "static/media/arrow-line_dark.0d25f2c6e079a63f368f9e10b55f56e1.svg";
export { ForwardRef as ReactComponent };